import styles from '../css/CopyrightHolders.module.css';

const About = () => {
  return (
    <div className={styles.copyrightPage}>
      <div className={styles.container}>
        <h1 className={styles.title}>О сайте</h1>

        <div className={styles.content}>
          <p className={styles.paragraph}>
            DoramaHype — это каталог азиатских сериалов с русской озвучкой: корейских дорам, японских аниме и дорам,
            тайских лакорнов и других популярных шоу Азии. Мы собрали в одном месте всё,
            что нужно поклонникам азиатского кино и сериалов.
          </p>

          <div className={styles.requirements}>
            <h2 className={styles.subtitle}>Что такое DoramaHype</h2>
            <p className={styles.paragraph}>
              Сайт был создан для любителей азиатских сериалов, которые хотят легко находить новые тайтлы,
              следить за онгоингами, составлять списки просмотренного и общаться с единомышленниками.
              Мы постоянно обновляем каталог: добавляем новые сериалы, озвучки и информацию о выходе новых серий.
            </p>
          </div>

          <div className={styles.requirements}>
            <h2 className={styles.subtitle}>Возможности сайта</h2>
            <ul className={styles.list}>
              <li>Обширный каталог корейских дорам, японских и тайских сериалов с описаниями и оценками.</li>
              <li>Удобный поиск и фильтрация по жанрам, странам, годам выпуска и рейтингу.</li>
              <li>Список онгоингов с отслеживанием выхода новых серий.</li>
              <li>Личный кабинет: история просмотров, закладки, собственные оценки.</li>
              <li>Рейтинги пользователей и топ-100 лучших сериалов по версии сообщества.</li>
            </ul>
          </div>

          <div className={styles.requirements}>
            <h2 className={styles.subtitle}>Контакты</h2>
            <p className={styles.paragraph}>
              По всем вопросам, предложениям и сотрудничеству вы можете написать нам на почту:
            </p>
            <p className={styles.email}>
              📧 doramahype@gmail.com
            </p>
            <p className={styles.paragraph}>
              Если вы являетесь правообладателем и хотите подать обращение — воспользуйтесь страницей{' '}
              <a href="/copyright" style={{color: 'var(--accent-color)'}}>Правообладателям</a>.
              По вопросам размещения рекламы — страница{' '}
              <a href="/advertise" style={{color: 'var(--accent-color)'}}>Рекламодателям</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
